import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Password',
  subtitle: 'Change your password regularly to keep your account secure',
  currentPasswordTitle: 'Current password',
  currentPasswordPlaceholder: 'Please enter your current password',
  newPasswordTitle: 'New password',
  newPasswordPlaceholder: 'Please enter your new password',
  confirmPasswordTitle: 'Confirm password',
  confirmPasswordPlaceholder: 'Please enter your new password again',
  saveChanges: 'Save changes',
  passwordUpdateFailed:
    'Oops! The current password you entered is incorrect. Please double-check and try again.',
  passwordUpdateSuccessful: 'Successfully updated password',
};

const welsh = {
  title: 'Cyfrinair',
  subtitle: "Newidwch eich cyfrinair yn rheolaidd i gadw'ch cyfrif yn ddiogel",
  currentPasswordTitle: 'Cyfrinair presennol',
  currentPasswordPlaceholder: 'Rhowch eich cyfrinair presennol',
  newPasswordTitle: 'Cyfrinair newydd',
  newPasswordPlaceholder: 'Rhowch eich cyfrinair newydd',
  confirmPasswordTitle: 'Cadarnhau cyfrinair',
  confirmPasswordPlaceholder: 'Rhowch eich cyfrinair newydd eto',
  saveChanges: 'Cadw newidiadau',
  passwordUpdateFailed:
    "Wps! Mae'r cyfrinair presennol a gawsoch ei fewnforio yn anghywir. Rhowch yn ofalus a cheisiwch eto.",
  passwordUpdateSuccessful: "Cyfrinair wedi'i ddiweddaru'n llwyddiannus",
};

export const securityUserProfileText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
